<template>
  <v-container>
      <c-card outlined class="pl-12 white">
        <v-row class="mb-2" justify="center" align="center">
          <v-icon size="40" color="blue">check_circle</v-icon>
          <span class="ml-3" style="font-size: 20px">예약 접수 완료</span>
        </v-row>
        <reservation-detail-dialog :reservationData="reservationCheckData" :reservationStateEventFlag="false" :coupon-info="couponInfo"></reservation-detail-dialog>

        <v-divider></v-divider>
        <v-row class="pa-0 ma-0">
          <v-col cols="12" md="2" sm="6">
            <span class="font-weight-black">배차 방식</span>
          </v-col>
          <v-col cols="12" md="4" sm="6" >
            <v-radio-group v-model="reservationType" row class="pa-0 ma-0">
              <v-radio label="자동배차" value="auto"></v-radio>
              <v-radio label="수동배차" value="manual"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </c-card>
  </v-container>
</template>
<script>
import ReservationDetailDialog from "@/views/CallTaxi/Reserve/ReservationDetailDialog";
  export default {
    components: {ReservationDetailDialog},
    props: {
      reservationCheckData: {
        type: Object,
        default: {}
      },
      couponInfo: {
        type: String,
      }
    },
    data() {
      return {
        reservationType: 'auto',
      }
    },
    watch: {
      reservationType(newVal) {
        this.$emit('update:reservationType', newVal);
      }
    },
  }
</script>
<style scoped>
  .waypoint {
    margin-top: 3px;
  }
</style>
